"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _MobileMenu = _interopRequireDefault(require("./MobileMenu/MobileMenu"));

var _DesktopMenu = _interopRequireDefault(require("./DesktopMenu"));

var _MetaHeader = _interopRequireDefault(require("../MetaHeader"));

var _Logo = _interopRequireDefault(require("./Logo"));

var _Hamburger = _interopRequireDefault(require("./Hamburger"));

var _Container = _interopRequireDefault(require("../../components/Container"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // Main wrapper of all the header


var HeaderTag = (0, _styled["default"])('header')(function (_ref) {
  var theme = _ref.theme;
  return {
    position: 'relative',
    borderTop: "2px solid ".concat(theme.colors.primary)
  };
}); // Bottom part of the header

var MainHeader = (0, _styled["default"])('div')({
  backgroundColor: '#fff',
  zIndex: 12,
  position: 'relative',
  boxShadow: '0 10px 8px -14px rgba(0,0,0,0.3)'
}); // Wrapper of the bottom part of the header containing logo, menu, etc...

var Wrapper = (0, _styled["default"])('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap'
});
var LeftElements = (0, _styled["default"])('div')({
  display: 'flex'
});

var Header2 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Header2, _React$Component);

  function Header2() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Header2);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Header2)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      menuOpen: false
    });

    return _this;
  }

  _createClass(Header2, [{
    key: "toggleMenu",
    value: function toggleMenu() {
      this.setState(function (prevState) {
        return {
          menuOpen: !prevState.menuOpen
        };
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      /**
       * Jeremy's solution to menu overflow.
       * body is not a solution, break on safari
       * use #root because we pretty sure it exists
       */
      var root = document.querySelector('#root');

      if (root) {
        root.style['overflow-x'] = 'hidden';
        root.style['min-height'] = '100vh';
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          notifications = _this$props.notifications,
          logo = _this$props.logo,
          menu = _this$props.menu,
          metaHeaderMenu = _this$props.metaHeaderMenu;
      return _react["default"].createElement(HeaderTag, {
        open: this.state.menuOpen
      }, metaHeaderMenu && metaHeaderMenu.length > 0 ? _react["default"].createElement(_MetaHeader["default"], {
        notifications: notifications,
        menus: metaHeaderMenu
      }) : null, _react["default"].createElement(MainHeader, null, _react["default"].createElement(_Container["default"], null, _react["default"].createElement(Wrapper, null, _react["default"].createElement(LeftElements, null, logo ? _react["default"].createElement(_Logo["default"], logo) : null), menu ? _react["default"].createElement(_DesktopMenu["default"], {
        links: menu
      }) : null, _react["default"].createElement(_Hamburger["default"], {
        open: this.state.menuOpen,
        onClick: this.toggleMenu.bind(this)
      })))), _react["default"].createElement(_MobileMenu["default"], {
        links: menu,
        open: this.state.menuOpen
      }));
    }
  }]);

  return Header2;
}(_react["default"].Component);

Header2.propTypes = {
  /**
   * label and url for the contact element on metaheader menu
   */
  // contact: MetaHeader.propTypes.contact,
  // /**
  //  * label and url for the notifications element on metaheader menu
  //  */
  // notifications: MetaHeader.propTypes.notifications,

  /**
   * user object for user element on metaheader menu
   */
  // user: MetaHeader.propTypes.user,

  /**
   * langs objets for lang element on metaheader menu
   */
  // langs: MetaHeader.propTypes.langs,

  /**
   * Logo properties for Logo element
   */
  logo: _propTypes["default"].shape(_Logo["default"].propTypes),

  /**
   * Entities selector properties
   */
  // entities: PropTypes.object,

  /**
   * Menu properties
   */
  menu: _DesktopMenu["default"].propTypes.links
};
var _default = Header2;
exports["default"] = _default;